import React, {useContext, useEffect, useState} from 'react';
import {Button, Col, ConfigProvider, DatePicker, Form, Input, Modal, Row, Select, Table, Tag} from 'antd';
import Colors from "../../../styles/Colors";
import {BiCheck, BiX} from "react-icons/bi";
import locale from "antd/es/locale/es_ES";
import {GetEscoles} from "../../../dao/root/GetEscoles";
import { PostProposta } from '../../../dao/menudesign/comandes/PostProposta';
import {AuthContext} from "../../../config/AuthContext";
import Proposta from "../../../model/menudesign/comandes/Proposta";
import {ColumnsType, TableProps} from "antd/es/table";
import {GetComandaId} from "../../../dao/menudesign/comandes/GetComandaId";
import dayjs from "dayjs";
import Ingredient from '../../../model/menudesign/Ingredient';
import { GetComandaIngredient } from '../../../dao/menudesign/comandes/GetComandaIngredient';
import {useNavigate, useParams} from "react-router-dom";
import {format} from "date-fns";


interface PropostatModalProps {
    element: string;
    visible: boolean;
    onClose: () => void;
    
}

const ComandaFinalizadaModal: React.FC<PropostatModalProps> = ({element, visible, onClose}) => {
    const [form] = Form.useForm();
    const navigate = useNavigate();
    const {isLoggedIn, userId, user, page} = useContext(AuthContext);
    const [coleccio, setDades] = useState<any[]>([]);
    const [loading, setLoading] = useState(false);
    const esSuperusuari = user?.rol?.some((rol: any) => rol.nom === "superusuari");
    

   useEffect(() => {
        if (isLoggedIn) {
            checkDades();
        }
    }, [isLoggedIn]);

    async function checkDades() {
        try {
            const dades = await GetComandaIngredient(page,Number(element));
            
            if (!dades) {
                setDades([]);
                return;
            }
            setDades(dades);
    

        } catch (error) {
            console.error("Error en checkDades:", error);
            setDades([]);
        }
        }

    async function handleCancel() {
        await onClose();
    };
    const tableProps: TableProps<Ingredient> = {
        loading
    };

    const onChange: TableProps<Ingredient>['onChange'] =
        (pagination,
         filters,
         sorter,
         extra) => {
            console.log('params', pagination, filters, sorter, extra);
    };

    const columns: ColumnsType<any> = [
        {
            key: 'id_ingredient',
            dataIndex: 'id_ingredient',
            title: 'ID'
        },
        {
            key: 'nom',
            dataIndex: 'nom',
            title: 'Ingredient'
        },
        {
            key: 'quatitat',
            dataIndex: 'quatitat',
            title: 'Quantitat',
            render: (valor) => (
            <Tag color={Colors.colors.color4}><span>{parseFloat(valor).toFixed(2)}</span></Tag>
            ),
        },
        {
            key: 'mesura',
            dataIndex: 'mesura',
            title: 'Mesura'
        },
        {
            key: 'dia',
            dataIndex: 'dia',
            title: 'Dia',
            render: (estat, ele) => (
                <Tag>{format(new Date(ele.dia), 'dd-MM-yyyy')}</Tag>
            )
        },
        {
            key: 'afegit',
            dataIndex: 'afegit',
            title: 'Afegit',
            render: (afegit, ele) => (
                <Tag color={afegit === 1 ? Colors.colors.color2 : Colors.colors.color5}>{afegit === 1 ? "SÍ" : "NO"}</Tag>
            )
        },
        
    ];
    

    return (
        <ConfigProvider locale={locale}>
        <Modal
            title="Resum de la comanda finalitzada"
            open={visible}
            onCancel={handleCancel}
            footer={[
            ]}
            width={600}
        >
            
                <hr/>
                   <Table
                        {...tableProps}
                        onChange={onChange}
                        columns={columns}
                        pagination={{pageSize: 100}}
                        dataSource={coleccio}
                    />

       
            
        </Modal>
        </ConfigProvider>
    );
};

export default ComandaFinalizadaModal;
